<template>
<div class="row mt-4">
    <h4 class="w100 pad-15 auto ">{{headingText}}</h4>
    <div v-for="item in filterItems" :key="item.product_id" class="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
        <!-- <v-lazy v-model="item.isActive" :options="{
                                threshold: .5
                            }"> -->
        <div class="show-product-wrap product">
            <div class="col-xl-11 col-lg-11 col-11 product-show-wrap auto sh3 mb-2">
                <div class="c-wrap position-relative p-3">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on" class="wish-fav">
                                <v-icon class="wishlist-icon" @click="heartClick($event,item.product_id)">
                                    {{getWishText(item.wishlist_bit)}}
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Add to Wishlist</span>
                    </v-tooltip>

                    <!-- Product Name -->
                    <h2 class="product-h">{{item.name}}</h2>
                    <div class="w100">
                        <!-- P-Packing  -->
                        <span class="packing-p">{{item.packing_name}} {{item.brand_name}}</span>
                        <!-- P-price -->
                    </div><span class="p-price"> &#8377;{{item.discount_price}}/- &nbsp;
                        <s v-if="item.discount_price != item.mrp" class="actual-price">&#8377; {{item.mrp}}/-</s></span>

                    <p class="subtotal" v-if="itemInCart(item.product_id)>=0">{{getSubtotal(item.product_id)}}</p>
                    <!-- {{itemInCart(item.product_id)}} -->

                    <div class="cta-atc-wrap">
                        <!-- qty increase or decrease -->
                        <div class="qtySelector text-center mt-2" v-if="itemInCart(item.product_id)>=0">
                            <!-- <button >+</button> -->

                            <i class="increaseQty fa-plus fa" @click="subqty(item.product_id)">
                                <v-icon>remove</v-icon>
                            </i>

                            <input type="text" class="qtyValue" :value="qtyInCart(item.product_id)">
                            <i @click="addqty(item.product_id)" class="decreaseQty fa fa-minus">
                                <v-icon>add</v-icon>
                            </i>

                        </div>
                        <!-- Add to cart Btn -->
                        <div class="add-to-cart " v-if="itemInCart(item.product_id)<0">
                            <button class="p-cta-btn" @click="addToCart(item.product_id,item.name,item.discount_price,item.packing_name,item.measure)">Add to Cart</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- </v-lazy> -->

    </div>
    <div v-observe-visibility="handleScrolledToBottom" v-if="headingText=='Product List'">Loading Data...</div>
    <Checkout :cart="cart" v-if="cart.length>0"></Checkout>
<div v-if="ProductList.length==0 && headingText=='Wishlist'">
<h3>No Data Found!</h3>

</div>

</div>
</template>

<script>
import axios from "axios"
import Checkout from './Checkout.vue'
import myFunctions from './globalMixins'
import ApiList from './ApiList'
export default {
    name: 'RecyclerView',
    components: {
        Checkout
    },
    props: {
        selecetdCatg: String,
        headingText: String,
        searchText: String,
        searchBrand: Array
    },
    mixins: [myFunctions, ApiList],
    data() {
        return {
            loading: false,
            isActive: false,
            newUrl: "",
            ProductList: [],
            // filterItems:[],
            cart: [],
            total: '0',
            customer_id: -1,
            subTotalCheck: false,
            // apiPath: '',
            param: '',
            page: 1,
            lastPage: 1,
        }
    },
    mounted() {
        this.loadData()
    },
    methods: {
        loadData() {
            this.headingTextValue = this.headingText;
            this.customer_id = localStorage.customer_id;
            if (this.cart.length > 0) {
                if (this.cart[0].cid != this.customer_id) {
                    this.clearCart()
                }
            }
            this.fetch()

            if (localStorage.getItem("cart") === null) {
                this.cart = []
            } else {
                this.cart = JSON.parse(localStorage.getItem("cart"));
            }

        },
        async fetch() {
            if (this.headingText == "Product List" || this.headingText == "All Products") {
                this.apiPath = this.apis.productListUrl
                this.param = {
                    params: {
                        token: localStorage.token,
                        customer_id: this.customer_id,
                        page_no: this.page,
                    }
                }
            } else if (this.headingText == "Top 10") {
                this.apiPath = this.apis.top10ProductUrl
                this.param = {
                    params: {
                        token: localStorage.token
                    }
                }
            } else if (this.headingText == "My favorite") {
                this.apiPath = this.apis.frequentOrdersUrl
                this.param = {
                    params: {
                        token: localStorage.token,
                        customer_id: this.customer_id,
                        page_no: this.page,
                    }
                }
            } else if (this.headingText == "Offers") {
                this.apiPath = this.apis.productListUrl
                this.param = {
                    params: {
                        token: localStorage.token,
                        discount_only: 1,
                        page_no: this.page,
                    }
                }
            } else if (this.headingText == "Wishlist") {
                this.apiPath = this.apis.productListUrl
                this.param = {
                    params: {
                        token: localStorage.token,
                        wishlist_only: 1,
                        page_no: this.page,
                        customer_id: this.customer_id,

                    }
                }
            }
            this.newUrl = this.apis.apiUrl + this.apiPath
            // this.param = {params:{}}
            await axios.get(this.newUrl, this.param)
                .then((response) => {
                    // console.log(response)
                    if (this.page == 1) {
                        this.ProductList = []
                    }
                    // this.ProductList = response.data
                    this.ProductList.push(...response.data)
                    // alert(this.selecetdCatg)
                    if (this.selecetdCatg != "All") {
                        this.ProductList = this.ProductList.filter(product => product.category === this.selecetdCatg)
                        // console.log("Products : " + this.ProductList)
                    }
                })
        },
        handleScrolledToBottom(isVisible) {
            if (!isVisible) {
                return
            }
            this.page++
            //this.$emit('navBarChange', false);
            this.fetch()
            // console.log("page - " + this.page)
        },
        addNewObject(pid, pname, price, packing, measure) {
            this.cart.push({
                product_id: pid,
                name: pname,
                mrp: price,
                qty: 1,
                cid: this.customer_id > 0 ? this.customer_id : "",
                packing: packing,
                measure: measure
            });
        },
        itemInCart(pid) {
            if (this.cart != null && this.cart.length > 0) {
                var objIndex = this.cart.findIndex((obj => obj.product_id == pid));
                //alert(objIndex)
                return objIndex;
            }
            return -1;
        },

        qtyInCart(pid) {
            if (this.cart != null || this.cart.length > 0) {
                var objIndex = this.cart.findIndex((obj => obj.product_id == pid));
                var q = this.cart[objIndex].qty;
                return q;
            }
        },
        getSubtotal(pid) {
            var index = -1
            index = this.itemInCart(pid)
            var total = 0
            //   console.log("index = "+index)
            if (index >= 0) {
                var qty = this.qtyInCart(pid)
                var mrp = this.cart[index].mrp
                total = parseInt(qty) * parseInt(mrp)
                this.subTotalCheck = true

            }
            return total
            // return index
        },
        getWishText(txt) {
            if (txt == 1)
                return "favorite"
            else
                return "favorite_border"
        },
        filterByBrandName(products) {
            // var text = this.searchBrand[0]
            if (this.searchBrand == null || this.searchBrand.length == 0) {
                return products
            } else {
                return products.filter((item) => {
                    return this.searchBrand.includes(item.brand_name)
                    //return (item.brand_name.match(text));
                });
            }
        },
        filterBySearchText(products) {
            if (this.searchText == null) {
                //    console.log("empty text")
                return products
            } else
                return products.filter((item) => {
                    return (item.name.toLowerCase().match(this.searchText.toLowerCase()) || item.category.toLowerCase().match(this.searchText.toLowerCase()) || item.brand_name.toLowerCase().match(this.searchText.toLowerCase()));
                });
        },

    },
    watch: {
        selecetdCatg: function () {
            this.loadData()
        },
        headingText: function () { // watch it
            this.loadData()
        },

    },
    computed: {
        filterItems: function () {
           if(this.searchText!=null)
           {
           if (this.searchText.length == 0 && this.searchBrand.length == 0) {
                // console.log("all products")
                return this.ProductList;
            } else {
                return this.filterBySearchText(this.filterByBrandName(this.ProductList))

            }
           }
           else
              return this.ProductList;
        },

    },
}
</script>
